import {
  Module,
  VuexModule,
  Mutation,
  getModule,
} from "vuex-module-decorators";
import store from "@/store";
import { createDefaultSystemConfiguration, SystemConfiguration } from "@/data/models/Client";

const name = "systemConfiguration";

@Module({ dynamic: true, namespaced: true, store, name: name })
export class SystemConfigurationVuexModule extends VuexModule {
  systemConfiguration: SystemConfiguration = createDefaultSystemConfiguration();

  /**
   * Whether the client's system configuration has been read from Firestore yet, or found missing.
   *
   * The defaults above are indistinguishable from a real document, and the observer that replaces
   * them is wired up in `Scaffold`, which mounts only after `router.beforeEach` resolves. The route
   * guard therefore loads it once itself and needs to know whether that has happened.
   */
  hasLoaded = false;

  @Mutation
  setSystemConfiguration(systemConfiguration: SystemConfiguration) {
    this.systemConfiguration = systemConfiguration;
    this.hasLoaded = true;
  }

  /** Records that the document was read and does not exist, so the defaults are the real state. */
  @Mutation
  markLoaded() {
    this.hasLoaded = true;
  }

  @Mutation
  clear() {
    this.systemConfiguration = createDefaultSystemConfiguration();
    this.hasLoaded = false;
  }
}

export const SystemConfigurationModule = getModule(SystemConfigurationVuexModule, store);
